export enum ETetePrelevement {
    D37mm = 1,
    Cathia = 2,
    Quales = 3,
}